import Vue from 'vue'



import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(ViewUI)
import 'font-awesome/css/font-awesome.css'
import '../src/assets/font/font.css'
import fxlogin from '@skyland/fxlogin'
Vue.use(fxlogin);

// import Login from './views/Login.vue'
import Login from './views/Login.vue'

Vue.config.productionTip = false
new Vue({
    render: h => h(Login),
}).$mount('#login')
